import { Dialog } from '@headlessui/react';
import React from 'react';

import Modal from './Modal';

const ModalConfirmation = (props: {
  icon: string;
  title: string;
  description: string;
  cancelButtonRef: React.MutableRefObject<null>;
  isShowModal: boolean;
  isLoading?: boolean;
  closeModal?: () => void;
  closeModalBackground: () => void;
  onClick?: () => void;
  variantButton: 'SINGLE' | 'DOUBLE' | 'NONE';
  textCenter?: string;
  textLeft?: string;
  textRight?: string;
}) => {
  return (
    <Modal
      cancelButtonRef={props.cancelButtonRef}
      isShowModal={props.isShowModal}
      closeModalBackground={props.closeModalBackground}>
      <div className="flex justify-center items-center mb-8">
        <img src={props.icon} className="w-18 h-auto" />
      </div>
      <div className={props.variantButton === 'NONE' ? 'text-center -mb-6' : 'text-center mb-6'}>
        <Dialog.Title
          as="div"
          className="laptop:text-extraLarge tablet:text-extraLarge mobile:large text-gray-gray700 font-interMedium">
          {props.title}
        </Dialog.Title>
        <div className="mt-3">
          <p className="laptop:text-large tablet:text-large mobile:text-regular text-gray-gray600 font-interRegular">
            {props.description}
          </p>
        </div>
      </div>
      {props.variantButton === 'SINGLE' ? (
        <button
          ref={props.cancelButtonRef}
          type="button"
          onClick={props.onClick}
          className="w-full px-4 py-4 text-center rounded-lg
        bg-primary-green focus:outline-none focus:ring-transparent focus:ring-primary-green">
          <div className="laptop:text-large tablet:text-large mobile:text-regular text-white font-interSemiBold">
            {props.textCenter}
          </div>
        </button>
      ) : props.variantButton === 'DOUBLE' ? (
        <div className="flex space-x-4">
          <button
            type="button"
            className="w-1/2 flex justify-center items-center text-center p-4 text-center border-2 bg-white rounded-lg focus:outline-none focus:ring-transparent border-primary-green"
            onClick={props.closeModal}
            ref={props.cancelButtonRef}>
            <div className="laptop:text-large tablet:text-large mobile:text-regular text-primary-green font-interSemiBold">
              {props.textLeft}
            </div>
          </button>
          <button
            type="button"
            className="w-1/2 p-4 flex justify-center items-center text-center rounded-lg
            bg-primary-green focus:outline-none focus:ring-transparent focus:ring-primary-green"
            onClick={props.onClick}>
            {props.isLoading ? (
              <div>
                <img src="/images/spinner.gif" className="w-6 h-6" />
              </div>
            ) : (
              <div className="laptop:text-large tablet:text-large mobile:text-regular text-white font-interSemiBold">
                {props.textRight}
              </div>
            )}
          </button>
        </div>
      ) : (
        <button ref={props.cancelButtonRef} />
      )}
    </Modal>
  );
};

export default ModalConfirmation;
